<template>
  <div class="table-container">

    <table class="copyable-table">
      <caption>{{ responseData.title }}</caption>
      <thead>
        <tr>
          <th v-for="(header, key) in headers" :key="key" @click="sortData(key)">
            {{ header }}
            <span v-if="sortKey === key" :class="sortOrder === 'asc' ? 'sort-icon-asc' : 'sort-icon-desc'"></span>
          </th>

        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, rowIndex) in sortedData" :key="rowIndex">
          <td v-for="(value, key) in row" :key="key">
            {{ value }}
          </td>
          <td>
            <a href="#" @click="handleOnPrice(row)">报价</a>
            <br />
            <a href="#" @click="handleOnLine(row)">雪球</a>
            <br />
            <a href="#" @click="handleOnWenCai(row)">问财</a>
               <br/>
            <a href="#" @click="handleLHB(row)">龙虎榜</a>
          </td>
        </tr>
      </tbody>
    </table>
     <button @click="copyTableToImage" class="button text-list-button">复制成图片</button>
  </div>
</template>

<script>
import { copyTableToImage } from '@/utils/utils';
import { onPrice1, onLine1, onWenCai1,onLHB1 } from '@/utils/commonMethods';

export default {
  props: {
    responseData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      currentPage: 1,
      itemsPerPage: 10,
      sortKey: '',
      sortOrder: 'asc',
      currentDate: new Date().toLocaleDateString()
    };
  },
  computed: {
    headers() {
      return this.responseData.headers || [];
    },
    sortedData() {
      const dataCopy = this.responseData.data && Array.isArray(this.responseData.data)
        ? JSON.parse(JSON.stringify(this.responseData.data))
        : [];
      if (!this.sortKey) return dataCopy;

      return dataCopy.sort((a, b) => {
        const aValue = a[this.sortKey];
        const bValue = b[this.sortKey];
        if (aValue < bValue) return this.sortOrder === 'asc' ? -1 : 1;
        if (aValue > bValue) return this.sortOrder === 'asc' ? 1 : -1;
        return 0;
      });
    }
  },
  methods: {
    sortData(key) {
      if (this.sortKey === key) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortKey = key;
        this.sortOrder = 'asc';
      }
      console.log(`Sorting by ${key} in ${this.sortOrder} order`);
    },
    handleOnPrice(row) {
      onPrice1(this.responseData, row, this.$router); // 使用导入的 onPrice 方法
    },
    handleOnLine(row) {
      onLine1(this.responseData, row, this.$router); // 使用导入的 onPrice 方法
    },
    handleOnWenCai(row) {
      onWenCai1(this.responseData, row, this.$router); // 使用导入的 onPrice 方法
    },
     handleLHB(row) {
      onLHB1(this.responseData, row, this.$router); // 使用导入的 onPrice 方法
    },
    copyTableToImage() {
      const table = this.$el.querySelector('table');
      const fileName = '个股涨停情况_' + this.currentDate + '.png';
      copyTableToImage(table, fileName);
    },
  }
};
</script>

<style scoped>
@import '../assets/css/ChildComponent.css';
@import '../assets/css/Common.css';
@import '../assets/css/App.css';

.sort-icon-asc::after {
  content: '↑';
  margin-left: 4px;
}

.sort-icon-desc::after {
  content: '↓';
  margin-left: 4px;
}
</style>
